import { render, staticRenderFns } from "./PrintReport.vue?vue&type=template&id=0d6f52f0&"
import script from "./PrintReport.vue?vue&type=script&lang=ts&"
export * from "./PrintReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports